/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const InfoTypeDict = {
  Town: {
    label: 'Miejscowość:',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica:',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku:',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu:',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy:',
    editable: true,
  },
  AddressDistrict: {
    label: 'Poczta:',
    editable: true,
  },
};

class ZmianaAdrDoKorespondencji extends React.Component {
  state = {
    info: {
      Town: null,
      AddressStreet: null,
      AddressNumber: null,
      AddressFlat: null,
      AddressZipCode: null,
      AddressDistrict: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
  };

  validators = {
    Town: [v.NotNull],
    AddressNumber: [v.NotNull],
    AddressZipCode: [v.NotNull],
    AddressDistrict: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onHide = () => this.setState({ showError: false });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        Town: 'Warszawa',
        AddressStreet: 'Testowa',
        AddressNumber: '5',
        AddressFlat: '12',
        AddressZipCode: '11-111',
        AddressDistrict: 'Warszawa' },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: {},
          selectedParcels: {},
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <DecisionContainer
          title={'1. Nowy adres do korespondencji'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ZmianaAdrDoKorespondencji.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZmianaAdrDoKorespondencji),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZmianaAdrDoKorespondencji.js